import {
  fetchAndActivate,
  getAll,
  getRemoteConfig,
} from 'firebase/remote-config';
import { initializeApp } from 'firebase/app';
import firebaseConfig from './firebaseConfig';

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Remote Config
const remoteConfig = getRemoteConfig(app);

// Optional: Set minimum fetch interval (for development)
remoteConfig.settings.minimumFetchIntervalMillis =
  import.meta.env.VITE_ENV === 'PROD' ? 3600000 : 60000; // 1 hour in prod - 1 mimute in NON prod env

type FBRemoteConfigItemType = {
  _value: string;
};

type FBRemoteConfigListType = Record<string, FBRemoteConfigItemType>;

// Export helper to fetch and get values
// @ts-expect-error force custom firebase config type
const fetchRemoteConfig: () => Promise<FBRemoteConfigListType> = async () => {
  try {
    await fetchAndActivate(remoteConfig);
    return getAll(remoteConfig);
  } catch (error) {
    console.error('Failed to fetch Remote Config:', error);
    return remoteConfig.defaultConfig;
  }
};

const FB_CONFIG_KEYS = {
  FIREBASE_OVERDUE_PHONE: 'DASHBOARD_OVERDUE_PHONE',
};

export { FB_CONFIG_KEYS, fetchRemoteConfig, remoteConfig };
